import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { getString } from '@/modules/common/helpers/resources';
import {
  checkResetToken,
  commitResetToken,
  getThemeByParam,
  unblockHash,
  verifyAccountPassword
} from '@/modules/common/services/http/account';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import {
  getPasswordCriteriaStatus,
  isPasswordValid
} from '@/modules/authentication/helpers/password-criteria';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { notify } from '@/modules/common/helpers/notification';
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading,
  InputPassword,
  LoaderIndicator,
  Modal,
  ModalButton,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoading = ref(true);
const comittingSetup = ref(false);
const unblockModalOpen = ref(false);
const setupToken = ref(route.params.token as string);
const password = ref('');

const enableButton = computed(() => isPasswordValid(password.value));
const hasPasswordInput = computed(() => Boolean(password.value));

const passwordRules = computed(() => {
  const criteria = getPasswordCriteriaStatus(password.value);
  const getStatus = (isValid: boolean) => {
    if (!hasPasswordInput.value) return 'neutral';
    return isValid ? 'valid' : 'invalid';
  };

  return [
    {
      id: 'min-length',
      label: 'Ter pelo menos 8 caracteres',
      isValid: criteria.hasMinLength,
      status: getStatus(criteria.hasMinLength)
    },
    {
      id: 'special-char',
      label: 'Ter um caractere especial (!@#/$%&*)',
      isValid: criteria.hasSpecialChar,
      status: getStatus(criteria.hasSpecialChar)
    },
    {
      id: 'no-sequence-repetition',
      label: 'Não ter sequências ou repetições (123, aaa)',
      isValid: criteria.hasNoSequenceOrRepetition,
      status: getStatus(criteria.hasNoSequenceOrRepetition)
    }
  ];
});

onMounted(async () => {
  try {
    await checkResetToken({ hash: setupToken.value });
    isLoading.value = false;
  } catch (error) {
    if (error instanceof Error && error.message === 'error_account_blocked') {
      unblockModalOpen.value = true;
    } else {
      notify({
        group: 'wrn-notifications',
        text: 'OPS! ESTA CHAVE DE ACESSO TEMPORÁRIA É INVÁLIDA',
        type: NotificationTypes.error
      });
      setTimeout(() => {
        router.push({ name: 'v3' });
      }, 2000);
    }
  }
});

const commitSetup = async () => {
  comittingSetup.value = true;
  try {
    const verification = await verifyAccountPassword({
      password: password.value
    });
    if (!verification.isValid) {
      comittingSetup.value = false;
      notify({
        group: 'wrn-notifications',
        text: verification.tip || 'Não foi possivel registrar a nova senha.',
        type: NotificationTypes.error
      });
      return;
    }

    const response = await commitResetToken({
      hash: setupToken.value,
      password: password.value
    });
    notify({
      group: 'wrn-notifications',
      text: 'Senha alterada com sucesso.',
      type: NotificationTypes.success
    });

    const theme = await getThemeByParam('email', response.user.email);
    const { domain, platform } = getDomainAndPlatform(theme);

    window.location.href = `/onboarding/${domain}/${platform}/login`;
  } catch {
    comittingSetup.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possivel registrar a nova senha.',
      type: NotificationTypes.error
    });
  }
};
const unblockAccount = async () => {
  try {
    await unblockHash({ hash: setupToken.value, type: 'reset-password' });
    notify({
      group: 'wrn-notifications',
      text: getString('dialog_unblock_success'),
      type: NotificationTypes.success
    });
  } catch {
    comittingSetup.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possivel desbloquear.',
      type: NotificationTypes.error
    });
  }
};
const closeUnblockModal = () => {
  router.push({ name: 'v3' });
};

return { __sfc: true,route, router, isLoading, comittingSetup, unblockModalOpen, setupToken, password, enableButton, hasPasswordInput, passwordRules, commitSetup, unblockAccount, closeUnblockModal, getString, NebraskaColors, BaseText, ButtonContainer, ButtonPrimary, Heading, InputPassword, LoaderIndicator, Modal, ModalButton, NavBar }
}

})